/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { AlphabetLetter, WordItem } from '../types';

export const URDU_ALPHABET: AlphabetLetter[] = [
  { letter: 'ا', transliteration: 'Alif', name: 'الف', wordLocal: 'انار', wordTranslation: 'Anaar', wordImageEmoji: '🍎', phonetic: 'alif' },
  { letter: 'ب', transliteration: 'Be', name: 'بے', wordLocal: 'بلی', wordTranslation: 'Billi', wordImageEmoji: '🐱', phonetic: 'bey' },
  { letter: 'پ', transliteration: 'Pe', name: 'پے', wordLocal: 'پتنگ', wordTranslation: 'Patang', wordImageEmoji: '🪁', phonetic: 'pey' },
  { letter: 'ت', transliteration: 'Te', name: 'تے', wordLocal: 'تتلی', wordTranslation: 'Titli', wordImageEmoji: '🦋', phonetic: 'tey' },
  { letter: 'ٹ', transliteration: 'Tte', name: 'ٹے', wordLocal: 'ٹماٹر', wordTranslation: 'Tamatar', wordImageEmoji: '🍅', phonetic: 'ttey' },
  { letter: 'ث', transliteration: 'Se', name: 'ثے', wordLocal: 'ثمر', wordTranslation: 'Samar', wordImageEmoji: '🧺🍎🍌🍇', phonetic: 'sey' },
  { letter: 'ج', transliteration: 'Jeem', name: 'جیم', wordLocal: 'جہاز', wordTranslation: 'Jahaz', wordImageEmoji: '✈️', phonetic: 'jeem' },
  { letter: 'چ', transliteration: 'Che', name: 'چے', wordLocal: 'چڑیا', wordTranslation: 'Chirya', wordImageEmoji: '🐦', phonetic: 'chey' },
  { letter: 'ح', transliteration: 'He', name: 'حے', wordLocal: 'حلوہ', wordTranslation: 'Halwa', wordImageEmoji: '🍮', phonetic: 'hey' },
  { letter: 'خ', transliteration: 'Khe', name: 'خے', wordLocal: 'خرگوش', wordTranslation: 'Khargosh', wordImageEmoji: '🐰', phonetic: 'khey' },
  { letter: 'د', transliteration: 'Dal', name: 'دال', wordLocal: 'درخت', wordTranslation: 'Darakht', wordImageEmoji: '🌳', phonetic: 'daal' },
  { letter: 'ڈ', transliteration: 'Ddal', name: 'ڈال', wordLocal: 'ڈولفن', wordTranslation: 'Dolphin', wordImageEmoji: '🐬', phonetic: 'ddaal' },
  { letter: 'ذ', transliteration: 'Zal', name: 'ذال', wordLocal: 'ذہن', wordTranslation: 'Zehn', wordImageEmoji: '🧠', phonetic: 'zaal' },
  { letter: 'ر', transliteration: 'Re', name: 'رے', wordLocal: 'ریل', wordTranslation: 'Rail', wordImageEmoji: '🚂', phonetic: 'rey' },
  { letter: 'ڑ', transliteration: 'Rre', name: 'ڑے', wordLocal: 'پہاڑ', wordTranslation: 'Pahar', wordImageEmoji: '⛰️', phonetic: 'rrey' },
  { letter: 'ز', transliteration: 'Ze', name: 'زے', wordLocal: 'زیبرا', wordTranslation: 'Zebra', wordImageEmoji: '🦓', phonetic: 'zey' },
  { letter: 'ژ', transliteration: 'Zhe', name: 'ژے', wordLocal: 'ژالہ باری', wordTranslation: 'Zalabari', wordImageEmoji: '🌨️', phonetic: 'zhey' },
  { letter: 'س', transliteration: 'Seen', name: 'سین', wordLocal: 'سیب', wordTranslation: 'Seeb', wordImageEmoji: '🍎', phonetic: 'seen' },
  { letter: 'ش', transliteration: 'Sheen', name: 'شین', wordLocal: 'شیر', wordTranslation: 'Sheer', wordImageEmoji: '🦁', phonetic: 'sheen' },
  { letter: 'ص', transliteration: 'Saad', name: 'صاد', wordLocal: 'صندوق', wordTranslation: 'Sandooq', wordImageEmoji: '📦', phonetic: 'saad' },
  { letter: 'ض', transliteration: 'Daad', name: 'ضاد', wordLocal: 'ضد', wordTranslation: 'Zid', wordImageEmoji: '😤', phonetic: 'daad' },
  { letter: 'ط', transliteration: 'Toe', name: 'طوئے', wordLocal: 'طوطا', wordTranslation: 'Tota', wordImageEmoji: '🦜', phonetic: 'toey' },
  { letter: 'ظ', transliteration: 'Zoe', name: 'ظوئے', wordLocal: 'ظرف', wordTranslation: 'Zarf', wordImageEmoji: '🥣', phonetic: 'zoey' },
  { letter: 'ع', transliteration: 'Ain', name: 'عین', wordLocal: 'عینک', wordTranslation: 'Ainak', wordImageEmoji: '👓', phonetic: 'ain' },
  { letter: 'غ', transliteration: 'Ghain', name: 'غین', wordLocal: 'غبارہ', wordTranslation: 'Ghubara', wordImageEmoji: '🎈', phonetic: 'ghain' },
  { letter: 'ف', transliteration: 'Fe', name: 'فے', wordLocal: 'فوارہ', wordTranslation: 'Fawara', wordImageEmoji: '⛲', phonetic: 'fey' },
  { letter: 'ق', transliteration: 'Qaf', name: 'قاف', wordLocal: 'قلم', wordTranslation: 'Qalam', wordImageEmoji: '🖊️', phonetic: 'qaaf' },
  { letter: 'ک', transliteration: 'Kaf', name: 'کاف', wordLocal: 'کتاب', wordTranslation: 'Kitab', wordImageEmoji: '📖', phonetic: 'kaaf' },
  { letter: 'گ', transliteration: 'Gaf', name: 'گاف', wordLocal: 'گائے', wordTranslation: 'Gaaye', wordImageEmoji: '🐄', phonetic: 'gaaf' },
  { letter: 'ل', transliteration: 'Lam', name: 'لام', wordLocal: 'لیموں', wordTranslation: 'Laimon', wordImageEmoji: '🍋', phonetic: 'laam' },
  { letter: 'م', transliteration: 'Meem', name: 'میم', wordLocal: 'مچھلی', wordTranslation: 'Machli', wordImageEmoji: '🐟', phonetic: 'meem' },
  { letter: 'ن', transliteration: 'Noon', name: 'نون', wordLocal: 'ناریل', wordTranslation: 'Nariyal', wordImageEmoji: '🥥', phonetic: 'noon' },
  { letter: 'و', transliteration: 'Wao', name: 'واؤ', wordLocal: 'وردی', wordTranslation: 'Wardi', wordImageEmoji: '👔', phonetic: 'wao' },
  { letter: 'ہ', transliteration: 'He', name: 'ہے', wordLocal: 'ہاتھی', wordTranslation: 'Haathi', wordImageEmoji: '🐘', phonetic: 'hey' },
  { letter: 'ھ', transliteration: 'Do Chashmi He', name: 'دو چشمی ہے', wordLocal: 'پھول', wordTranslation: 'Phool', wordImageEmoji: '🌸', phonetic: 'hey-do-chashmi' },
  { letter: 'ء', transliteration: 'Hamza', name: 'ہمزہ', wordLocal: 'آئینہ', wordTranslation: 'Aaina', wordImageEmoji: '🪞', phonetic: 'hamza' },
  { letter: 'ی', transliteration: 'Ye', name: 'یے', wordLocal: 'یکہ', wordTranslation: 'Yakka', wordImageEmoji: '🐎', phonetic: 'yey' },
  { letter: 'ے', transliteration: 'Bari Ye', name: 'بڑی یے', wordLocal: 'کمرے', wordTranslation: 'Kamray', wordImageEmoji: '🛋️', phonetic: 'bari-yey' }
];

export const URDU_WORDS: WordItem[] = [
  { id: 'ur_1', emoji: '🦁', word: 'شیر', phonetic: 'Sheer', category: 'animals' },
  { id: 'ur_2', emoji: '🐘', word: 'ہاتھی', phonetic: 'Haathi', category: 'animals' },
  { id: 'ur_3', emoji: '🐒', word: 'بندر', phonetic: 'Bandar', category: 'animals' },
  { id: 'ur_4', emoji: '🍎', word: 'سیب', phonetic: 'Seeb', category: 'fruits' },
  { id: 'ur_5', emoji: '🍌', word: 'کیلا', phonetic: 'Keela', category: 'fruits' },
  { id: 'ur_6', emoji: '🍊', word: 'مالٹا', phonetic: 'Malta', category: 'fruits' },
  { id: 'ur_7', emoji: '🚗', word: 'گاڑی', phonetic: 'Gari', category: 'vehicles' },
  { id: 'ur_8', emoji: '✈️', word: 'جہاز', phonetic: 'Jahaz', category: 'vehicles' },
  { id: 'ur_9', emoji: '🚂', word: 'ریل گاڑی', phonetic: 'Rail Gari', category: 'vehicles' },
  { id: 'ur_10', emoji: '☀️', word: 'سورج', phonetic: 'Suraj', category: 'nature' },
  { id: 'ur_11', emoji: '🌧️', word: 'بارش', phonetic: 'Barish', category: 'nature' },
  { id: 'ur_12', emoji: '🌸', word: 'پھول', phonetic: 'Phool', category: 'nature' },
  { id: 'ur_13', emoji: '🧸', word: 'بھالو', phonetic: 'Bhaloo', category: 'objects' },
  { id: 'ur_14', emoji: '🎈', word: 'غبارہ', phonetic: 'Ghubara', category: 'objects' },
  { id: 'ur_15', emoji: '🎒', word: 'بستہ', phonetic: 'Basta', category: 'objects' }
];

export const EXPLORER_URDU_ALPHABET_WORDS: Record<string, { word: string; icon: string; audioKey: string }[]> = {
  'ا': [
    { word: 'انار', icon: '🍎', audioKey: 'anaar' },
    { word: 'املی', icon: '🫚', audioKey: 'imli' },
    { word: 'انگوٹھی', icon: '💍', audioKey: 'angothi' },
    { word: 'استاد', icon: '👨‍🏫', audioKey: 'ustad' },
    { word: 'اخبار', icon: '📰', audioKey: 'akhbar' }
  ],
  'ب': [
    { word: 'بلی', icon: '🐱', audioKey: 'billi' },
    { word: 'بطخ', icon: '🦆', audioKey: 'batakh' },
    { word: 'بکری', icon: '🐐', audioKey: 'bakri' },
    { word: 'باجا', icon: '🎺', audioKey: 'baja' },
    { word: 'بادل', icon: '☁️', audioKey: 'badal' }
  ],
  'پ': [
    { word: 'پتنگ', icon: '🪁', audioKey: 'patang' },
    { word: 'پنکھا', icon: '🌀', audioKey: 'pankha' },
    { word: 'پیاز', icon: '🧅', audioKey: 'piyaz' },
    { word: 'پودا', icon: '🌱', audioKey: 'poda' },
    { word: 'پتا', icon: '🍃', audioKey: 'patta' }
  ],
  'ت': [
    { word: 'تتلی', icon: '🦋', audioKey: 'titli' },
    { word: 'تربوز', icon: '🍉', audioKey: 'tarbooz' },
    { word: 'تارا', icon: '⭐', audioKey: 'tara' },
    { word: 'تالا', icon: '🔒', audioKey: 'tala' },
    { word: 'ترازو', icon: '⚖️', audioKey: 'tarazoo' }
  ],
  'ٹ': [
    { word: 'ٹماٹر', icon: '🍅', audioKey: 'tamatar' },
    { word: 'ٹوپی', icon: '🧢', audioKey: 'topi' },
    { word: 'ٹوکری', icon: '🧺', audioKey: 'tokri' },
    { word: 'ٹرک', icon: '🚚', audioKey: 'truck' },
    { word: 'ٹب', icon: '🛁', audioKey: 'tub' }
  ],
  'ث': [
    { word: 'ثمر', icon: '🧺🍎🍌🍇', audioKey: 'samar' },
    { word: 'ثواب', icon: '🤝', audioKey: 'sawab' },
    { word: 'ثریا', icon: '✨', audioKey: 'surayya' },
    { word: 'ثانی', icon: '⏱️', audioKey: 'saani' },
    { word: 'ثروت', icon: '💰', audioKey: 'sarwat' }
  ],
  'ج': [
    { word: 'جہاز', icon: '✈️', audioKey: 'jahaz' },
    { word: 'جوتا', icon: '👟', audioKey: 'joota' },
    { word: 'جگ', icon: '🫖', audioKey: 'jug' },
    { word: 'جال', icon: '🕸️', audioKey: 'jaal' },
    { word: 'جراب', icon: '🧦', audioKey: 'jurab' }
  ],
  'چ': [
    { word: 'چڑیا', icon: '🐦', audioKey: 'chirya' },
    { word: 'چاند', icon: '🌙', audioKey: 'chaand' },
    { word: 'چابی', icon: '🔑', audioKey: 'chabi' },
    { word: 'چمچ', icon: '🥄', audioKey: 'chamach' },
    { word: 'چوہا', icon: '🐭', audioKey: 'chooha' }
  ],
  'ح': [
    { word: 'حلوہ', icon: '🍮', audioKey: 'halwa' },
    { word: 'حوض', icon: '💧', audioKey: 'hawz' },
    { word: 'حجام', icon: '💇', audioKey: 'hajam' },
    { word: 'حنا', icon: '🌿', audioKey: 'hinna' },
    { word: 'حجرہ', icon: '🏠', audioKey: 'hujra' }
  ],
  'خ': [
    { word: 'خرگوش', icon: '🐰', audioKey: 'khargosh' },
    { word: 'خربوزہ', icon: '🍈', audioKey: 'kharbooza' },
    { word: 'خط', icon: '✉️', audioKey: 'khat' },
    { word: 'خیمہ', icon: '⛺', audioKey: 'khaima' },
    { word: 'خوبانی', icon: '🍑', audioKey: 'khubani' }
  ],
  'د': [
    { word: 'درخت', icon: '🌳', audioKey: 'darakht' },
    { word: 'دوات', icon: '✒️', audioKey: 'dawat' },
    { word: 'دستانے', icon: '🧤', audioKey: 'dastaney' },
    { word: 'دانت', icon: '🦷', audioKey: 'daant' },
    { word: 'دروازہ', icon: '🚪', audioKey: 'darwaza' }
  ],
  'ڈ': [
    { word: 'ڈولفن', icon: '🐬', audioKey: 'dolphin' },
    { word: 'ڈبہ', icon: '📦', audioKey: 'dabba' },
    { word: 'ڈبل روٹی', icon: '🍞', audioKey: 'double_roti' },
    { word: 'ڈاکٹر', icon: '🧑‍⚕️', audioKey: 'doctor' },
    { word: 'ڈول', icon: '🪣', audioKey: 'dool' }
  ],
  'ذ': [
    { word: 'ذہن', icon: '🧠', audioKey: 'zehn' },
    { word: 'ذکر', icon: '📖', audioKey: 'zikr' },
    { word: 'ذائقہ', icon: '😋', audioKey: 'zaiqa' },
    { word: 'ذرا', icon: '🤏', audioKey: 'zara' },
    { word: 'ذریعہ', icon: '🛤️', audioKey: 'zariya' }
  ],
  'ر': [
    { word: 'ریل', icon: '🚂', audioKey: 'rail' },
    { word: 'رسی', icon: '🪢', audioKey: 'rassi' },
    { word: 'ریچھ', icon: '🐻', audioKey: 'reech' },
    { word: 'روبوٹ', icon: '🤖', audioKey: 'robot' },
    { word: 'رنگ', icon: '🎨', audioKey: 'rang' }
  ],
  'ڑ': [
    { word: 'پہاڑ', icon: '⛰️', audioKey: 'pahar' },
    { word: 'گاڑی', icon: '🚗', audioKey: 'gari' },
    { word: 'لڑکا', icon: '👦', audioKey: 'larka' },
    { word: 'لڑکی', icon: '👧', audioKey: 'larki' },
    { word: 'جھاڑو', icon: '🧹', audioKey: 'jharoo' }
  ],
  'ز': [
    { word: 'زیبرا', icon: '🦓', audioKey: 'zebra' },
    { word: 'زنجیر', icon: '⛓️', audioKey: 'zanjeer' },
    { word: 'زبان', icon: '👅', audioKey: 'zaban' },
    { word: 'زرافہ', icon: '🦒', audioKey: 'zarafa' },
    { word: 'زردآلو', icon: '🍑', audioKey: 'zardaloo' }
  ],
  'ژ': [
    { word: 'ژالہ باری', icon: '🌨️', audioKey: 'zalabari' },
    { word: 'ژوب', icon: '📍', audioKey: 'zhob' },
    { word: 'ژرف', icon: '🌊', audioKey: 'zharf' },
    { word: 'ژولیدہ', icon: '🧶', audioKey: 'zholida' },
    { word: 'ژرفا', icon: '⚓', audioKey: 'zharfa' }
  ],
  'س': [
    { word: 'سیب', icon: '🍎', audioKey: 'seeb' },
    { word: 'سورج', icon: '☀️', audioKey: 'suraj' },
    { word: 'سیڑھی', icon: '🪜', audioKey: 'seedhi' },
    { word: 'سائیکل', icon: '🚲', audioKey: 'cycle' },
    { word: 'ستارہ', icon: '⭐', audioKey: 'sitara' }
  ],
  'ش': [
    { word: 'شیر', icon: '🦁', audioKey: 'sheer' },
    { word: 'شتر مرغ', icon: '🦩', audioKey: 'shutur_murgh' },
    { word: 'شہد', icon: '🍯', audioKey: 'shahad' },
    { word: 'شیشہ', icon: '🪞', audioKey: 'sheesha' },
    { word: 'شلجم', icon: '🧅', audioKey: 'shaljam' }
  ],
  'ص': [
    { word: 'صندوق', icon: '📦', audioKey: 'sandooq' },
    { word: 'صابن', icon: '🧼', audioKey: 'sabon' },
    { word: 'صوفہ', icon: '🛋️', audioKey: 'sofa' },
    { word: 'صراحی', icon: '🏺', audioKey: 'surahi' },
    { word: 'صبح', icon: '🌅', audioKey: 'subah' }
  ],
  'ض': [
    { word: 'ضد', icon: '😤', audioKey: 'zid' },
    { word: 'ضبط', icon: '🧘', audioKey: 'zabt' },
    { word: 'ضابطہ', icon: '📋', audioKey: 'zabta' },
    { word: 'ضمیر', icon: '💭', audioKey: 'zameer' },
    { word: 'ضلع', icon: '🗺️', audioKey: 'zila' }
  ],
  'ط': [
    { word: 'طوطا', icon: '🦜', audioKey: 'tota' },
    { word: 'طشتری', icon: '🍽️', audioKey: 'tashtari' },
    { word: 'طیارہ', icon: '✈️', audioKey: 'tayyara' },
    { word: 'طبلہ', icon: '🪘', audioKey: 'tabla' },
    { word: 'طوفان', icon: '🌪️', audioKey: 'toofan' }
  ],
  'ظ': [
    { word: 'ظرف', icon: '🥣', audioKey: 'zarf' },
    { word: 'ظاہر', icon: '👁️', audioKey: 'zahir' },
    { word: 'ظلم', icon: '🚫', audioKey: 'zulm' },
    { word: 'ظرافت', icon: '😄', audioKey: 'zarafat' },
    { word: 'ظہور', icon: '🌅', audioKey: 'zuhoor' }
  ],
  'ع': [
    { word: 'عینک', icon: '👓', audioKey: 'ainak' },
    { word: 'عقاب', icon: '🦅', audioKey: 'uqaab' },
    { word: 'عمارت', icon: '🏢', audioKey: 'imarat' },
    { word: 'عطر', icon: '🧪', audioKey: 'itar' },
    { word: 'عدالت', icon: '🏛️', audioKey: 'adalat' }
  ],
  'غ': [
    { word: 'غبارہ', icon: '🎈', audioKey: 'ghubara' },
    { word: 'غار', icon: '🕳️', audioKey: 'ghaar' },
    { word: 'غلیل', icon: '🪵', audioKey: 'ghulel' },
    { word: 'غوطہ خور', icon: '🤿', audioKey: 'ghota_khor' },
    { word: 'غزال', icon: '🦌', audioKey: 'ghazaal' }
  ],
  'ف': [
    { word: 'فوارہ', icon: '⛲', audioKey: 'fawara' },
    { word: 'فاختہ', icon: '🐦', audioKey: 'fakhta' },
    { word: 'فوجی', icon: '🪖', audioKey: 'fouji' },
    { word: 'فون', icon: '📞', audioKey: 'phone' },
    { word: 'فائل', icon: '📁', audioKey: 'file' }
  ],
  'ق': [
    { word: 'قلم', icon: '🖊️', audioKey: 'qalam' },
    { word: 'قینچی', icon: '✂️', audioKey: 'qenchi' },
    { word: 'قالین', icon: '🧣', audioKey: 'qaleen' },
    { word: 'قفل', icon: '🔒', audioKey: 'qufl' },
    { word: 'قوس قزح', icon: '🌈', audioKey: 'qous_e_quzah' }
  ],
  'ک': [
    { word: 'کتاب', icon: '📖', audioKey: 'kitab' },
    { word: 'کرسی', icon: '🪑', audioKey: 'kursi' },
    { word: 'کبوتر', icon: '🐦', audioKey: 'kabootar' },
    { word: 'کیلا', icon: '🍌', audioKey: 'kela' },
    { word: 'کتا', icon: '🐶', audioKey: 'kutta' }
  ],
  'گ': [
    { word: 'گائے', icon: '🐄', audioKey: 'gaaye' },
    { word: 'گڑیا', icon: '🪆', audioKey: 'guriya' },
    { word: 'گیند', icon: '⚽', audioKey: 'gend' },
    { word: 'گاجر', icon: '🥕', audioKey: 'gajar' },
    { word: 'گھوڑا', icon: '🐴', audioKey: 'ghora' }
  ],
  'ل': [
    { word: 'لیموں', icon: '🍋', audioKey: 'leemon' },
    { word: 'لوٹا', icon: '🫖', audioKey: 'lota' },
    { word: 'لکڑی', icon: '🪵', audioKey: 'lakri' },
    { word: 'لڑکا', icon: '👦', audioKey: 'larka_boy' },
    { word: 'لومڑی', icon: '🦊', audioKey: 'lomri' }
  ],
  'م': [
    { word: 'مچھلی', icon: '🐟', audioKey: 'machli' },
    { word: 'مور', icon: '🦚', audioKey: 'moor' },
    { word: 'مسجد', icon: '🕌', audioKey: 'masjid' },
    { word: 'مالٹا', icon: '🍊', audioKey: 'malta_fruit' },
    { word: 'موم بتی', icon: '🕯️', audioKey: 'mombatti' }
  ],
  'ن': [
    { word: 'ناریل', icon: '🥥', audioKey: 'nariyal' },
    { word: 'نل', icon: '🚰', audioKey: 'nal' },
    { word: 'نقشہ', icon: '🗺️', audioKey: 'naqsha' },
    { word: 'ناشپاتی', icon: '🍐', audioKey: 'nashpati' },
    { word: 'نماز', icon: '🧎', audioKey: 'namaz' }
  ],
  'و': [
    { word: 'وردی', icon: '👔', audioKey: 'wardi' },
    { word: 'ورق', icon: '📄', audioKey: 'waraq' },
    { word: 'ویگن', icon: '🚐', audioKey: 'wagon' },
    { word: 'وزن', icon: '⚖️', audioKey: 'wazan' },
    { word: 'وادی', icon: '⛰️', audioKey: 'wadi' }
  ],
  'ہ': [
    { word: 'ہاتھی', icon: '🐘', audioKey: 'hathi' },
    { word: 'ہرن', icon: '🦌', audioKey: 'hiran' },
    { word: 'ہار', icon: '📿', audioKey: 'haar' },
    { word: 'ہاتھ', icon: '✋', audioKey: 'hath' },
    { word: 'ہتھوڑا', icon: '🔨', audioKey: 'hathora' }
  ],
  'ھ': [
    { word: 'پھول', icon: '🌸', audioKey: 'phool' },
    { word: 'بھالو', icon: '🧸', audioKey: 'bhaloo_bear' },
    { word: 'تھالی', icon: '🍽️', audioKey: 'thali' },
    { word: 'گھڑی', icon: '⌚', audioKey: 'ghari' },
    { word: 'چھتری', icon: '☂️', audioKey: 'chhatri' }
  ],
  'ء': [
    { word: 'آئینہ', icon: '🪞', audioKey: 'aaina' },
    { word: 'آئے', icon: '👋', audioKey: 'aaye' },
    { word: 'مسئلہ', icon: '❓', audioKey: 'masla' },
    { word: 'مؤذن', icon: '🕌', audioKey: 'moazzin' },
    { word: 'جائز', icon: '✅', audioKey: 'jaiz' }
  ],
  'ی': [
    { word: 'یکہ', icon: '🐎', audioKey: 'yakka' },
    { word: 'یادگار', icon: '🏛️', audioKey: 'yadgar' },
    { word: 'یاقوت', icon: '💎', audioKey: 'yaqoot' },
    { word: 'یاسمین', icon: '🌼', audioKey: 'yasmeen' },
    { word: 'یو یو', icon: '🪀', audioKey: 'yoyo' }
  ],
  'ے': [
    { word: 'کمرے', icon: '🛋️', audioKey: 'kamray' },
    { word: 'تارے', icon: '⭐', audioKey: 'tare' },
    { word: 'لڑکے', icon: '👦', audioKey: 'larkay' },
    { word: 'پودے', icon: '🌱', audioKey: 'podey' },
    { word: 'طوطے', icon: '🦜', audioKey: 'totay' }
  ]
};
